module.exports = __webpack_public_path__ + "img/cynj.9c922abd.png";